import React from "react";

export default function Disclaimer() {
  return (
    <section className="ae-section pt-28">
      <div className="ae-container max-w-3xl">
        <div className="ae-eyebrow mb-3">Legal</div>
        <h1 className="font-display text-4xl font-semibold text-[#101827] mb-6">Professional Disclaimer</h1>
        <div className="prose-ae space-y-4 text-[#1F2937] leading-relaxed">
          <p>Apurba Estate is an independent real estate consultancy and technical service brand. It is not a government authority, registration office, BL&LRO, advocate, or statutory approving body.</p>
          <p>Information on this website is for general informational purposes and does not constitute legal, financial, tax, architectural or statutory advice.</p>
          <p>Property transactions, land conversion, mutation, registration and allied approvals are subject to independent verification and the applicable law. Outcomes are at the discretion of the competent authority.</p>
          <p>Where RERA registration applies to a project or activity, verified registration details will be displayed before marketing or advertising that activity.</p>
          <p className="text-sm text-[#64748B] mt-6">For legal opinion, court representation, title certification or statutory approvals, please engage appropriately qualified or authorised professionals.</p>
        </div>
      </div>
    </section>
  );
}
